import React from 'react';
import { Box } from '@chakra-ui/react';

import InputLabel from '../../../../../components/form/InputLabel';

const JobInfoSection = ({ title, toolTip, children, cypressId }) => (
  <Box
    data-cy={cypressId}
    mb={8}
  >
    <InputLabel labelName={title} toolTip={toolTip} />
    {children}
  </Box>
);

export default JobInfoSection;
